















































import Vue from 'vue'
import api from '@/assets/api'

export default Vue.extend({
  data() {
    return {
      key: 'value',
    }
  },
  computed: {
    routes2() {
      let rr = api.userAppRoutes() as any
      const x = {} as any

      for (let i = 0; i < rr.length; i++) {
        const r = rr[i]
        if (!x[r.shared]) x[r.shared] = []
        x[r.shared].push(r)
      }
      return x
    },
  },
})
